<template>
  <transition name="slide-fade" mode="out-in" appear>
    <section v-if="isVisible" id="breadcrumb" class="breadcrumbbar container-fixed">
      <span class="sr-only">{{ $t('common.breadcrumbTitle') }}:</span>
      <transition-group tag="ol" name="group-fade" mode="out-in" class="breadcrumb" appear>
        <li v-for="parent in parents" :key="parseLink(parent)">
          <router-link :to="{ name: parseLink(parent), params: filteredParams(parent) }" v-html="translate(parent)"></router-link>
          <VSvgIcon name="section" variant="outlined" />
        </li>
        <li :key="$route.name" class="active" v-html="translate($route.name)"></li>
      </transition-group>
    </section>
  </transition>
</template>

<script>
import routes from '@routes';
import * as types from '@route-types';
import { parents } from '@/utils/navigation';
import VSvgIcon from '@/components/UI/VSvgIcon.vue';

export default {
  name: 'UiBreadcrumb',

  components: { VSvgIcon },

  props: {
    isNavigationFlat: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      hidden: routes.filter((r) => r.meta && r.meta.hideBreadcrumb === true).map((r) => r.name),
    };
  },

  computed: {
    parents() {
      let { name } = this.$route;
      const names = [];
      while (name) {
        if (this.hidden.includes(name)) return [];
        name = parents[name];
        names.push(name);
      }
      names.pop();
      names.reverse();
      if (this.isNavigationFlat && names.length) {
        names[0] = 'HOME';
      }
      return names;
    },

    isVisible() {
      return this.parents && this.parents.length;
    },
  },

  methods: {
    translate(key) {
      if (this.$te(`common.breadcrumb_${key}`)) {
        return this.$t(`common.breadcrumb_${key}`);
      }
      if (this.$te(`common.navigation_${key}`)) {
        return this.$t(`common.navigation_${key}`);
      }
      return key;
    },

    parseLink(name) {
      if (!types[name]) return types.HOME;
      return name;
    },

    filteredParams(routeName) {
      // filter route params that do not exist in route
      const match = this.$route.matched.filter((r) => r.name === routeName);
      if (match.length !== 1) return {};

      const keys = match[0].regex.keys.map((k) => k.name);
      const oldParams = this.$route.params;
      return Object.keys(oldParams)
        .filter((k) => keys.includes(k))
        .reduce((params, key) => {
          params[key] = oldParams[key];
          return params;
        }, {});
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@scss';
@media screen and (min-width: #{$grid-small-max}px) {
  #breadcrumb {
    height: 42px;
  }
}
/* stylelint-disable selector-pseudo-class-no-unknown */
:deep(.breadcrumb li + li)::before,
:deep(.breadcrumb-item + .breadcrumb-item)::before,
:deep(.icon-section)::before {
  display: none !important;
  content: none !important;
}
/* stylelint-enable selector-pseudo-class-no-unknown */
</style>
